import { render, staticRenderFns } from "./AssessmentsFilter.vue?vue&type=template&id=1f355552&scoped=true"
import script from "./AssessmentsFilter.vue?vue&type=script&lang=ts"
export * from "./AssessmentsFilter.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentsFilter.vue?vue&type=style&index=0&id=1f355552&prod&lang=css"
import style1 from "./AssessmentsFilter.vue?vue&type=style&index=1&id=1f355552&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f355552",
  null
  
)

export default component.exports